import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { useModalConfirm } from "@ryde/redux";
import { ConfirmResult, PriceRateAdditionPricingType } from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import { IPriceLevelItemItemForm } from "./price-level.models";

export const PriceLevelItemDisplay: FC<IPriceLevelItemItemForm> = ({
  removeHandler,
  pricingType,
  index,
  onEdit,
  value,
  disabledEdit,
  disabledRemove,
}) => {
  const { t } = useTranslation();
  const { confirmDialogResult } = useModalConfirm();
  const message = t(`general.ITEM_ARCHIVE_MESSAGE`);

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message,
    });

    if (confirmationResult === ConfirmResult.OK) {
      removeHandler?.(index || 0);
    }
  });

  return (
    <div className="price-level-item display-mode">
      <div className="price-level-item__data">
        {typeof value?.from === "number" && (
          <div className="price-level-item__data--row">
            <label>
              {pricingType === PriceRateAdditionPricingType.Time
                ? t("priceRate.formLabel.startFromTime")
                : t("priceRate.formLabel.startFromDistance")}
            </label>
            <div className="price-level-cell">{value?.from}</div>
          </div>
        )}
        {typeof value?.price === "number" && (
          <div className="price-level-item__data--row">
            <label>
              {pricingType === PriceRateAdditionPricingType.Time
                ? t("priceRate.formLabel.pricePerMinute")
                : t("priceRate.formLabel.pricePerKilometer")}
            </label>
            <div className="price-level-cell">{value?.price}</div>
          </div>
        )}
      </div>
      <div className="price-level-item__buttons">
        {!disabledEdit && (
          <ColorIconButton
            iconType="EDIT"
            edge="end"
            aria-label="edit"
            className="edit-button"
            onClick={() => {
              onEdit?.();
            }}
          />
        )}

        {!disabledRemove && (
          <ColorIconButton
            iconType="DELETE"
            edge="end"
            aria-label="delete"
            onClick={() => onArchiveClickEvent()}
          />
        )}
      </div>
    </div>
  );
};
